import type { ClubTheme } from './themes';

interface PostLabelsProps {
  labels: string[];
  theme: ClubTheme;
}

const LABEL_CONFIG: Record<string, { emoji: string; color: string; bg: string }> = {
  'open-discussion': { emoji: '💬', color: '#3B82F6', bg: '#3B82F620' },
  'debated':         { emoji: '⚖️', color: '#F59E0B', bg: '#F59E0B20' },
  'fact-checked':    { emoji: '🛡️', color: '#10B981', bg: '#10B98120' },
  'annotated':       { emoji: '📝', color: '#8B5CF6', bg: '#8B5CF620' },
  'resolved':        { emoji: '✅', color: '#6B7280', bg: '#6B728020' },
};

export default function PostLabels({ labels }: PostLabelsProps) {
  if (!labels || labels.length === 0) return null;

  return (
    <div className="mb-2 flex flex-wrap gap-1.5">
      {labels.map((label) => {
        const config = LABEL_CONFIG[label];
        if (!config) return null;
        return (
          <span
            key={label}
            className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold"
            style={{ backgroundColor: config.bg, color: config.color }}
          >
            <span>{config.emoji}</span>
            <span>{label.replace(/-/g, ' ')}</span>
          </span>
        );
      })}
    </div>
  );
}
